/**
 * Page Not found
 */
import Icon404 from 'src/assets/images/icons/empty-notification.svg';
import { LandingTopWidget } from 'src/presentations/components/organisms/landing';

const PageError: React.FC = () => (
  <div className='w-screen h-screen flex flex-col bg-neutral-10'>
    <div className='w-full'>
      <LandingTopWidget />
    </div>
    <div className='flex-1 flex flex-col items-center justify-center bg-neutral-10'>
      <div className=''>
        <img className='w-[12.5rem]' src={Icon404} alt='' />
      </div>
      <h1 className='text-60 text-neutral-50 font-bold'>500</h1>
      <h2 className='text-24 font-bold text-[#202020]'>Unexpected Error</h2>
      <h2 className='text-16 text-neutral-60'>System error</h2>
    </div>
  </div>
);

export default PageError;
